import SelfLifeDetails from './SelfLifeDetails.jsx';
// import SellerDetails from './SellerDetails.jsx';
// import BuyerDetails from './BuyerDetails.jsx';
import ServiceManagement from './ServiceManagement.jsx';
import ServiceDetails from './ServiceDetails.jsx';
import ServiceDescription from './ServiceDescription.jsx';

export default function AddServiceDetails({ onNext, id, formData,setServiceManagaementData, setServiceDetailsData,setSelfLifeData, setServiceDescriptionData,SelectedServiceImages, SelectedCertificatesImages }) {

    return (
        <div>
            {/* Project Management Section */}
            <div className="mx-10 my-5 p-5 rounded-xl shadow-lg border border-gray-100">
                <h1 className='text-xl font-semibold underline text-[#333] py-3'>Service Management Details</h1>
                <ServiceManagement
                    ServiceManagementdata={formData}
                    setServiceManagaementData={setServiceManagaementData}
                />
            </div>
            {/* Service Details Section */}
            <div className="mx-10 my-5 p-5 rounded-xl shadow-lg border border-gray-100">
                <h1 className='text-xl font-semibold underline text-[#333] py-3'>Service Details</h1>
                <ServiceDetails
                    serviceDetailsdata={formData}
                    setServiceDetailsData={setServiceDetailsData}
                    SelectedCertificatesImages={SelectedCertificatesImages}
                    SelectedServiceImages={SelectedServiceImages}
                />
            </div>
            <div className="mx-10 my-5 p-5 rounded-xl shadow-lg border border-gray-100">
                <h1 className='text-xl font-semibold underline text-[#333] py-3'>Self Life & Expiry Details</h1>
                <SelfLifeDetails
                    selfLifedata={formData}
                    setSelfLifeData={setSelfLifeData}
                />
            </div>

            {/* <div className="mx-10 my-5 p-5 rounded-xl shadow-lg border border-gray-100">
                <h1 className='text-xl font-semibold underline text-[#333] py-3'>Service Of Seller</h1>
                <SellerDetails
                    data={formData.sellerDetails}
                    setData={(data) => setFormData({ ...formData, sellerDetails: data })}
                />
            </div>

            <div className="mx-10 my-5 p-5 rounded-xl shadow-lg border border-gray-100">
                <h1 className='text-xl font-semibold underline text-[#333] py-3'>Service Of Buyer</h1>
                <BuyerDetails
                    data={formData.buyerDetails}
                    setData={(data) => setFormData({ ...formData, buyerDetails: data })}
                />
            </div> */}

            <div className="mx-10 my-5 p-5 rounded-xl shadow-lg border border-gray-100">
                <h1 className='text-xl font-semibold underline text-[#333] py-3'>Description About Services</h1>
                <ServiceDescription
                    ServiceDescriptiondata={formData}
                    setServiceDescriptionData={setServiceDescriptionData}
                />
            </div>

            <div className="flex justify-end m-10">
                <button
                    className="px-6 py-2 bg-[#FF0000]  text-white rounded-lg hover:bg-[#FF0000]"
                    onClick={onNext}>
                    Next
                    {/* {id ? 'Update Service' : 'Add Service'} */}
                </button>
            </div>
        </div>
    )
}
